import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Articles from "@/pages/Articles";
import ArticleDetail from "@/pages/ArticleDetail";
import About from "@/pages/About";
import Press from "@/pages/Press";
import Admin from "@/pages/Admin";
import WriterProfile from "@/pages/WriterProfile";
import Achievements from "@/pages/Achievements";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CookieConsent, { VisitorTracker } from "@/components/VisitorTracking";

function App() {
  return (
    <HelmetProvider>
      <div className="min-h-screen bg-white">
        <BrowserRouter>
          <VisitorTracker>
            <Navbar />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/articles" element={<Articles />} />
                <Route path="/articles/:slug" element={<ArticleDetail />} />
                <Route path="/writers/:slug" element={<WriterProfile />} />
                <Route path="/about" element={<About />} />
                <Route path="/press" element={<Press />} />
                <Route path="/achievements" element={<Achievements />} />
                <Route path="/admin" element={<Admin />} />
              </Routes>
            </main>
            <Footer />
            <CookieConsent />
            <Toaster position="bottom-right" />
          </VisitorTracker>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
